import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { buildSupportWhatsAppUrl } from "../../helpers/supportWhatsapp";

const WHATSAPP_MESSAGE =
  "¡Hola! Me gustaría recibir más información sobre Homelan.";
const PRIMARY = "#a02cc7";
const WHATSAPP_GREEN = "#25D366";

const href = buildSupportWhatsAppUrl(WHATSAPP_MESSAGE);

const WhatsappWidget = () => {
  const [open, setOpen] = useState(false);

  return (
    <div
      className="position-fixed"
      style={{ bottom: "2rem", right: "2rem", zIndex: 1080 }}
    >
      <div className="d-flex flex-column align-items-end">
        {open && (
          <div
            className="bg-white rounded shadow-lg mb-3 animate__animated animate__fadeInUp animate__faster overflow-hidden"
            style={{
              width: "20rem",
              maxWidth: "calc(100vw - 4rem)",
              borderRadius: "1rem",
            }}
          >
            {/* Header */}
            <div
              className="d-flex align-items-center p-3 text-white"
              style={{ backgroundColor: PRIMARY }}
            >
              <div
                className="d-flex align-items-center justify-content-center font-weight-bold position-relative mr-2"
                style={{
                  width: "2.75rem",
                  height: "2.75rem",
                  borderRadius: "50%",
                  backgroundColor: "rgba(255,255,255,0.2)",
                  fontSize: "1.1rem",
                }}
              >
                H
                <span
                  className="position-absolute"
                  style={{
                    bottom: 0,
                    right: 0,
                    width: "0.85rem",
                    height: "0.85rem",
                    borderRadius: "50%",
                    backgroundColor: "#4ade80",
                    border: `2px solid ${PRIMARY}`,
                  }}
                />
              </div>
              <div className="line-height-1">
                <div className="font-weight-bold">Equipo Homelan</div>
                <small style={{ opacity: 0.85 }}>
                  Normalmente respondemos en minutos
                </small>
              </div>
              <button
                type="button"
                onClick={() => setOpen(false)}
                aria-label="Cerrar"
                className="btn btn-link text-white p-0 ml-auto"
                style={{ lineHeight: 1 }}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>

            {/* Body */}
            <div className="p-3" style={{ backgroundColor: "#f8f9fa" }}>
              <div
                className="bg-white p-3 mb-3 shadow-sm"
                style={{
                  borderRadius: "1rem",
                  borderTopLeftRadius: "0.25rem",
                  fontSize: "0.9rem",
                  color: "#495057",
                  maxWidth: "85%",
                }}
              >
                👋 ¡Hola! ¿Tienes dudas sobre la gestión de tus propiedades?
                Escríbenos y te ayudamos al instante.
              </div>
              <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-block text-white font-weight-bold d-flex align-items-center justify-content-center"
                style={{ backgroundColor: WHATSAPP_GREEN, borderRadius: "0.75rem" }}
              >
                <FontAwesomeIcon icon={faWhatsapp} className="mr-2" size="lg" />
                Iniciar chat por WhatsApp
              </a>
            </div>
          </div>
        )}

        {/* Trigger pill */}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="Abrir chat de WhatsApp"
          className="btn d-flex align-items-center text-white font-weight-bold shadow"
          style={{
            backgroundColor: PRIMARY,
            borderRadius: "2rem",
            paddingTop: "0.6rem",
            paddingBottom: "0.6rem",
            paddingLeft: "0.6rem",
            paddingRight: "1.25rem",
          }}
        >
          <span
            className="d-flex align-items-center justify-content-center mr-2"
            style={{
              width: "2rem",
              height: "2rem",
              borderRadius: "50%",
              backgroundColor: "rgba(255,255,255,0.2)",
            }}
          >
            <FontAwesomeIcon icon={faWhatsapp} size="lg" />
          </span>
          {open ? "Cerrar" : "¿Necesitas ayuda?"}
        </button>
      </div>
    </div>
  );
};

export default WhatsappWidget;
